import React from 'react'
import Fragment from '../common/fragment'


function FragmentCG(props) {
  return (
    <Fragment pos="ggg" {...props}>
      <p>
“El comienzo del terror no es el atentado concreto llevado a cabo desde uno de los
lados, sino más bien la voluntad y la disposición de los partners en conflicto a
operar en un campo de batalla amplificado.” (Sloterdijk)
      </p>
    </Fragment>
  )
}


export default FragmentCG
